/**
 * @desc 查询生产计划设置
 */

import * as defs from '../../baseClass';
import { defHttp } from 'hailuo-http';
export interface Params {}

export function request(
  data: defs.SettingPlanSearchRequest,
): Promise<defs.StandardReturn<defs.Pager<defs.SettingPlanDTO>>> {
  return defHttp.post({
    url: '/web/setting/plan/search',
    data,
  });
}

export function mock(
  data: defs.SettingPlanSearchRequest,
): Promise<defs.StandardReturn<defs.Pager<defs.SettingPlanDTO>>> {
  return defHttp.post({
    url: '/mock/web/setting/plan/search',
    data,
  });
}
